import request from "@/common/request";
import { ItemDeRomaneio, ListagemItensRomaneio } from "@/models/Romaneio";
import { AxiosRequestConfig } from "axios";

const basePath = '/item-romaneio'

export const findItensRomaneio = async (
	params?: any,
	config?: AxiosRequestConfig,
): Promise<ListagemItensRomaneio> => 
	request.get(`${basePath}`, { params, ...config })

export const findAllItensRomaneio = async (
	romaneioId: string,
): Promise<ItemDeRomaneio[]> => 
	request.get(`${basePath}/all-items/${romaneioId}`)

export const findAllItensRomaneios = async (
	params?: any,
	config?: AxiosRequestConfig,
): Promise<ItemDeRomaneio[]> => 
	request.get(`${basePath}/all-items/multiplos-romaneios`, {params, ...config})